
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmNgodXf3KEntZF2wdPcIn64NBcw88ty3ZHugnS_lDr8Meta } from "/root/work/frontends/kakao_gino/pages/index.vue?macro=true";
import { default as dogmnEgeKVSAK_CayyHIPQpOL9oMDdyUVobcBvrY0qJdZwMeta } from "/root/work/frontends/kakao_gino/pages/virtual/dog.vue?macro=true";
import { default as horse_45HWv5oaQgTdlcfG1Z704EE_esZEdjql2oRLu1VpRSAsMeta } from "/root/work/frontends/kakao_gino/pages/virtual/horse.vue?macro=true";
import { default as indexKQg6JqtVtJ1hd_45768lq_45ATS33Q9RVp5hrMMjtkQrDqAMeta } from "/root/work/frontends/kakao_gino/pages/virtual/index.vue?macro=true";
import { default as footballTc_iGDxx8w5sGIpBQi6hlbdb1rEPheQmdXqGgDncQf4Meta } from "/root/work/frontends/kakao_gino/pages/virtual/football.vue?macro=true";
import { default as basketballN5mUil6pa_45rxdMVpLrI4d_OHm81An_I4B5k4SFRqXicMeta } from "/root/work/frontends/kakao_gino/pages/virtual/basketball.vue?macro=true";
import { default as virtual4nSw6jBbtrqNEd_3age7yp832wRiN1BGfdJQKTC51tUMeta } from "/root/work/frontends/kakao_gino/pages/virtual.vue?macro=true";
import { default as _91id_93RM3FDwaCP9gB_45xj7jfJuqocbq02jbN8zhibU8NUknIoMeta } from "/root/work/frontends/kakao_gino/pages/mgame/[id].vue?macro=true";
import { default as indexJy9zSbjZYulRO_lc3uYgLCQmiX73E3AJ2mh8uqMdveoMeta } from "/root/work/frontends/kakao_gino/pages/mgame/index.vue?macro=true";
import { default as indexEMLJ96cfDMmYuPJI48eJQnFFJBUVKl07fqXIHI3bOGMMeta } from "/root/work/frontends/kakao_gino/pages/casino/index.vue?macro=true";
import { default as eventU0lFN4hk5YygBqIaby0G0GkX5pfUQasOmEGVtGDAsuwMeta } from "/root/work/frontends/kakao_gino/pages/mypage/event.vue?macro=true";
import { default as indexuiT7qx_45kJuoX2hZIgQ_45pCl3x_45JHi8OLc6dmBC8ulqJ0Meta } from "/root/work/frontends/kakao_gino/pages/mypage/index.vue?macro=true";
import { default as pointoHFOBJsk_Payw8HFJueYoJB8xHmmvuoXJyDcV82JtZUMeta } from "/root/work/frontends/kakao_gino/pages/mypage/point.vue?macro=true";
import { default as _91id_93LlVsvfiNIUKbXl3mQOOIiRpYzNs_QhPpCNh4oZDSrD8Meta } from "/root/work/frontends/kakao_gino/pages/sports/cross/[id].vue?macro=true";
import { default as crossFPZbPgbiPh97H_bf3wmck1h826nvVT_45zTabk_4571aa3gMeta } from "/root/work/frontends/kakao_gino/pages/sports/cross.vue?macro=true";
import { default as index4js0XgGwlzFPKCa59AEh4l_45aSEaV_jxU7zz68NuionEMeta } from "/root/work/frontends/kakao_gino/pages/sports/index.vue?macro=true";
import { default as indextXOc_QIB_45FS_45bL1BYT_2pci0nCvKcAcfEYoxxkBsROUMeta } from "/root/work/frontends/kakao_gino/pages/esports/index.vue?macro=true";
import { default as couponyQqh9vDMuS9c3EZErqx9KlD2BpGaq1Tj_03uDFx7u8AMeta } from "/root/work/frontends/kakao_gino/pages/mypage/coupon.vue?macro=true";
import { default as notice8tPlDUgdDrrkzvK3xp96JvGsDcL9J_45RaBuyZEVZqgeMMeta } from "/root/work/frontends/kakao_gino/pages/mypage/notice.vue?macro=true";
import { default as _91id_93qWzPRZOdjaEqrKJtNhZj9Ag434uzAJmdI66Z7RP5gZQMeta } from "/root/work/frontends/kakao_gino/pages/sports/inplay/[id].vue?macro=true";
import { default as inplayfL_45ii3_45Ju_45nHvSss2yR3o7xHxAOLMRDykldS8ks_DmgMeta } from "/root/work/frontends/kakao_gino/pages/sports/inplay.vue?macro=true";
import { default as _91id_93MY09CYxiOEszBDk_45nnW9wixvj4kyWh2p3F0xDRcEWPwMeta } from "/root/work/frontends/kakao_gino/pages/esports/inplay/[id].vue?macro=true";
import { default as inplayEsxpm3UQC2psJB6sIKsc9cMw06zMR_zjA9F3VMsGQToMeta } from "/root/work/frontends/kakao_gino/pages/esports/inplay.vue?macro=true";
import { default as depositgKPyuQ5avZ2kxevhjCS09umR7c_xxtWGswskCuXymxkMeta } from "/root/work/frontends/kakao_gino/pages/mypage/deposit.vue?macro=true";
import { default as historyu2niZnU6L4a7Z4L_45YL4uLBbMUOFlIqI_PvU_wrcD_45nwMeta } from "/root/work/frontends/kakao_gino/pages/mypage/history.vue?macro=true";
import { default as inquirygXnB6awwp_23Oa2XeoT34m39FFcWmnLQibmC64Wkcx8Meta } from "/root/work/frontends/kakao_gino/pages/mypage/inquiry.vue?macro=true";
import { default as messageRv_45JHl8XIMK7bAXhhmRomcXvhXspIKDo8AI152vSPeMMeta } from "/root/work/frontends/kakao_gino/pages/mypage/message.vue?macro=true";
import { default as settingIUBKBJAyN2CVKQ1sHtJqszdOlAe9qS_45ulCJROQXO6ZgMeta } from "/root/work/frontends/kakao_gino/pages/mypage/setting.vue?macro=true";
import { default as _91id_930iu_45Vb7JkqZXfv1EA_BDmINKvCnGZT6SA8_bcE6UUTIMeta } from "/root/work/frontends/kakao_gino/pages/sports/special/[id].vue?macro=true";
import { default as specialHzftCyXx7AWK6HR9tphST6tYWqePvvmN4t5dl9fcpcUMeta } from "/root/work/frontends/kakao_gino/pages/sports/special.vue?macro=true";
import { default as exchangeWUL5X1jBIeI9b2V26G1AgYz7PBsn933rOEpAwr95QhAMeta } from "/root/work/frontends/kakao_gino/pages/mypage/exchange.vue?macro=true";
import { default as withdrawB1X_qjB6r06xyCRjek8dZ9nClt4JK2A5UlXhZxuBLgMMeta } from "/root/work/frontends/kakao_gino/pages/mypage/withdraw.vue?macro=true";
import { default as _91id_932XCC16z0zE4k60eDCa8_in6NvLHqzP_J4zdnu8Dd7K0Meta } from "/root/work/frontends/kakao_gino/pages/sports/prematch/[id].vue?macro=true";
import { default as prematchFidpr1xN1l8wNiNa66wZfvg47YMq46HZTYsayXRyVqQMeta } from "/root/work/frontends/kakao_gino/pages/sports/prematch.vue?macro=true";
import { default as _91id_93n1Ao7RCyEfjlazk5_45r0ZtAekmcVxr_CSf2HwhTvem2EMeta } from "/root/work/frontends/kakao_gino/pages/esports/prematch/[id].vue?macro=true";
import { default as prematchX2ksWZpXORIRqI7mSNqxOF3eYDyKupBSLzKESnXPCKcMeta } from "/root/work/frontends/kakao_gino/pages/esports/prematch.vue?macro=true";
import { default as recommendkMCtF8cwEyCNIK1kSbUOwUeNdQ3RX_45oZv8J22w2_45VTwMeta } from "/root/work/frontends/kakao_gino/pages/mypage/recommend.vue?macro=true";
import { default as _91id_93aY3yFZQPE7g_45DgxoylMOG0Jcz7WjkDSt8wvCSVLt7qkMeta } from "/root/work/frontends/kakao_gino/pages/casino/cards/[id].vue?macro=true";
import { default as indexDYw_456zWCCUkZbdR99g30fsnc_45MipzwI8KeF_bF3npi0Meta } from "/root/work/frontends/kakao_gino/pages/casino/main/index.vue?macro=true";
import { default as index7sEgGnTolma7_1fZrmMwekTp3voXqpBlJwliavDTFskMeta } from "/root/work/frontends/kakao_gino/pages/casino/slot/index.vue?macro=true";
import { default as attendance3cwPQjM0ojVIB1oQxgLI__45GJSfvGQMUJrBUtvk7jgtgMeta } from "/root/work/frontends/kakao_gino/pages/mypage/attendance.vue?macro=true";
import { default as index_454ZNTUlBQCHB_rjlJA4TUAuNI17y_456tbYz4NqgrCVdUMeta } from "/root/work/frontends/kakao_gino/pages/casino/cards/index.vue?macro=true";
import { default as index_45ugkD4T_wWOaIFA91zmnsCzcBK9lynuJCAg_51eK_45VwMeta } from "/root/work/frontends/kakao_gino/pages/casino/main/[id]/index.vue?macro=true";
import { default as index9iSD52ft1VTTPccwvcujIF1YxECXeichn9TxcugwQQIMeta } from "/root/work/frontends/kakao_gino/pages/casino/slot/[id]/index.vue?macro=true";
import { default as index4ch48_45aN8701axXf43K4ruglO0r_bXdfq6t6FIYN5NUMeta } from "/root/work/frontends/kakao_gino/pages/casino/main/[id]/[gameid]/index.vue?macro=true";
import { default as indexFAjsxqr_45Mp7opR7TYV95TkFS9V_45E_45DXzife4AL7oKB8Meta } from "/root/work/frontends/kakao_gino/pages/casino/slot/[id]/[gameid]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexmNgodXf3KEntZF2wdPcIn64NBcw88ty3ZHugnS_lDr8Meta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/index.vue")
  },
  {
    name: virtual4nSw6jBbtrqNEd_3age7yp832wRiN1BGfdJQKTC51tUMeta?.name,
    path: "/virtual",
    meta: { ...(virtual4nSw6jBbtrqNEd_3age7yp832wRiN1BGfdJQKTC51tUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual.vue"),
    children: [
  {
    name: "virtual-dog",
    path: "dog",
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual/dog.vue")
  },
  {
    name: "virtual-horse",
    path: "horse",
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual/horse.vue")
  },
  {
    name: "virtual",
    path: "",
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual/index.vue")
  },
  {
    name: "virtual-football",
    path: "football",
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual/football.vue")
  },
  {
    name: "virtual-basketball",
    path: "basketball",
    component: () => import("/root/work/frontends/kakao_gino/pages/virtual/basketball.vue")
  }
]
  },
  {
    name: "mgame-id",
    path: "/mgame/:id()",
    meta: { ...(_91id_93RM3FDwaCP9gB_45xj7jfJuqocbq02jbN8zhibU8NUknIoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mgame/[id].vue")
  },
  {
    name: "mgame",
    path: "/mgame",
    meta: { ...(indexJy9zSbjZYulRO_lc3uYgLCQmiX73E3AJ2mh8uqMdveoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mgame/index.vue")
  },
  {
    name: "casino",
    path: "/casino",
    meta: {"middleware":"auth"},
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/index.vue")
  },
  {
    name: "mypage-event",
    path: "/mypage/event",
    meta: { ...(eventU0lFN4hk5YygBqIaby0G0GkX5pfUQasOmEGVtGDAsuwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/event.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/index.vue")
  },
  {
    name: "mypage-point",
    path: "/mypage/point",
    meta: { ...(pointoHFOBJsk_Payw8HFJueYoJB8xHmmvuoXJyDcV82JtZUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/point.vue")
  },
  {
    name: "sports-cross",
    path: "/sports/cross",
    meta: crossFPZbPgbiPh97H_bf3wmck1h826nvVT_45zTabk_4571aa3gMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/cross.vue"),
    children: [
  {
    name: "sports-cross-id",
    path: ":id()",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/cross/[id].vue")
  }
]
  },
  {
    name: "sports",
    path: "/sports",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/index.vue")
  },
  {
    name: "esports",
    path: "/esports",
    meta: indextXOc_QIB_45FS_45bL1BYT_2pci0nCvKcAcfEYoxxkBsROUMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/esports/index.vue")
  },
  {
    name: "mypage-coupon",
    path: "/mypage/coupon",
    meta: { ...(couponyQqh9vDMuS9c3EZErqx9KlD2BpGaq1Tj_03uDFx7u8AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/coupon.vue")
  },
  {
    name: "mypage-notice",
    path: "/mypage/notice",
    meta: { ...(notice8tPlDUgdDrrkzvK3xp96JvGsDcL9J_45RaBuyZEVZqgeMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/notice.vue")
  },
  {
    name: "sports-inplay",
    path: "/sports/inplay",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/inplay.vue"),
    children: [
  {
    name: "sports-inplay-id",
    path: ":id()",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/inplay/[id].vue")
  }
]
  },
  {
    name: "esports-inplay",
    path: "/esports/inplay",
    meta: inplayEsxpm3UQC2psJB6sIKsc9cMw06zMR_zjA9F3VMsGQToMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/esports/inplay.vue"),
    children: [
  {
    name: "esports-inplay-id",
    path: ":id()",
    meta: _91id_93MY09CYxiOEszBDk_45nnW9wixvj4kyWh2p3F0xDRcEWPwMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/esports/inplay/[id].vue")
  }
]
  },
  {
    name: "mypage-deposit",
    path: "/mypage/deposit",
    meta: { ...(depositgKPyuQ5avZ2kxevhjCS09umR7c_xxtWGswskCuXymxkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/deposit.vue")
  },
  {
    name: "mypage-history",
    path: "/mypage/history",
    meta: { ...(historyu2niZnU6L4a7Z4L_45YL4uLBbMUOFlIqI_PvU_wrcD_45nwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/history.vue")
  },
  {
    name: "mypage-inquiry",
    path: "/mypage/inquiry",
    meta: { ...(inquirygXnB6awwp_23Oa2XeoT34m39FFcWmnLQibmC64Wkcx8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/inquiry.vue")
  },
  {
    name: "mypage-message",
    path: "/mypage/message",
    meta: { ...(messageRv_45JHl8XIMK7bAXhhmRomcXvhXspIKDo8AI152vSPeMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/message.vue")
  },
  {
    name: "mypage-setting",
    path: "/mypage/setting",
    meta: { ...(settingIUBKBJAyN2CVKQ1sHtJqszdOlAe9qS_45ulCJROQXO6ZgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/setting.vue")
  },
  {
    name: "sports-special",
    path: "/sports/special",
    meta: specialHzftCyXx7AWK6HR9tphST6tYWqePvvmN4t5dl9fcpcUMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/special.vue"),
    children: [
  {
    name: "sports-special-id",
    path: ":id()",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/special/[id].vue")
  }
]
  },
  {
    name: "mypage-exchange",
    path: "/mypage/exchange",
    meta: { ...(exchangeWUL5X1jBIeI9b2V26G1AgYz7PBsn933rOEpAwr95QhAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/exchange.vue")
  },
  {
    name: "mypage-withdraw",
    path: "/mypage/withdraw",
    meta: { ...(withdrawB1X_qjB6r06xyCRjek8dZ9nClt4JK2A5UlXhZxuBLgMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/withdraw.vue")
  },
  {
    name: "sports-prematch",
    path: "/sports/prematch",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/prematch.vue"),
    children: [
  {
    name: "sports-prematch-id",
    path: ":id()",
    component: () => import("/root/work/frontends/kakao_gino/pages/sports/prematch/[id].vue")
  }
]
  },
  {
    name: "esports-prematch",
    path: "/esports/prematch",
    meta: prematchX2ksWZpXORIRqI7mSNqxOF3eYDyKupBSLzKESnXPCKcMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/esports/prematch.vue"),
    children: [
  {
    name: "esports-prematch-id",
    path: ":id()",
    meta: _91id_93n1Ao7RCyEfjlazk5_45r0ZtAekmcVxr_CSf2HwhTvem2EMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/esports/prematch/[id].vue")
  }
]
  },
  {
    name: "mypage-recommend",
    path: "/mypage/recommend",
    meta: { ...(recommendkMCtF8cwEyCNIK1kSbUOwUeNdQ3RX_45oZv8J22w2_45VTwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/recommend.vue")
  },
  {
    name: "casino-cards-id",
    path: "/casino/cards/:id()",
    meta: { ...(_91id_93aY3yFZQPE7g_45DgxoylMOG0Jcz7WjkDSt8wvCSVLt7qkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/cards/[id].vue")
  },
  {
    name: "casino-main",
    path: "/casino/main",
    meta: { ...(indexDYw_456zWCCUkZbdR99g30fsnc_45MipzwI8KeF_bF3npi0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/main/index.vue")
  },
  {
    name: "casino-slot",
    path: "/casino/slot",
    meta: { ...(index7sEgGnTolma7_1fZrmMwekTp3voXqpBlJwliavDTFskMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/slot/index.vue")
  },
  {
    name: "mypage-attendance",
    path: "/mypage/attendance",
    meta: { ...(attendance3cwPQjM0ojVIB1oQxgLI__45GJSfvGQMUJrBUtvk7jgtgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/mypage/attendance.vue")
  },
  {
    name: "casino-cards",
    path: "/casino/cards",
    meta: { ...(index_454ZNTUlBQCHB_rjlJA4TUAuNI17y_456tbYz4NqgrCVdUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/cards/index.vue")
  },
  {
    name: "casino-main-id",
    path: "/casino/main/:id()",
    meta: { ...(index_45ugkD4T_wWOaIFA91zmnsCzcBK9lynuJCAg_51eK_45VwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/main/[id]/index.vue")
  },
  {
    name: "casino-slot-id",
    path: "/casino/slot/:id()",
    meta: index9iSD52ft1VTTPccwvcujIF1YxECXeichn9TxcugwQQIMeta || {},
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/slot/[id]/index.vue")
  },
  {
    name: "casino-main-id-gameid",
    path: "/casino/main/:id()/:gameid()",
    meta: { ...(index4ch48_45aN8701axXf43K4ruglO0r_bXdfq6t6FIYN5NUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/main/[id]/[gameid]/index.vue")
  },
  {
    name: "casino-slot-id-gameid",
    path: "/casino/slot/:id()/:gameid()",
    meta: { ...(indexFAjsxqr_45Mp7opR7TYV95TkFS9V_45E_45DXzife4AL7oKB8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/root/work/frontends/kakao_gino/pages/casino/slot/[id]/[gameid]/index.vue")
  }
]